<template>
    <div :style="[elementStyles, basicContentStyles]">
        <div :style="verticalAlign" v-html="currentTime"></div>
    </div>
</template>

<script>
    export default {
        props: ['data', 'frame', 'basicContentStyles', 'width', 'height'],
        data: function () {
            return {
                hours: '',
                minutes: '',
                timeoutHandle: null,
                intervalHandle: null
            }
        },
        computed: {
            elementStyles: function () {
                let opacity = 1;
                if (!isNaN(this.data.transparency)) {
                    opacity -= this.data.transparency/100;
                }
                // 0.999: such that border when selected is visualized correctly.
                opacity = Math.min(opacity, 0.999);

                let fontsize = 30;
                let fontfamily = 'Arial';

                if (typeof this.data.text_size !== 'undefined' && this.data.text_size !== null && this.data.text_size !== '') {
                    fontsize = this.data.text_size;
                }

                if (typeof this.data.text_family !== 'undefined' && this.data.text_family !== null && this.data.text_family.length > 0) {
                    fontfamily = this.data.text_family;
                }

                fontsize = parseInt(_.replace(fontsize, 'px', '')) * this.frame.ratio;

                return {
                    fontSize: fontsize + 'px',
                    fontFamily: '"' + fontfamily + '"',
                    textAlign: this.data.text_align,
                    textDecoration: this.textDecoration,
                    fontStyle: this.fontStyle,
                    fontWeight: this.fontWeight,
                    color: this.data.primary_color,
                    lineHeight: 'normal',
                    opacity: opacity,
                }
            },
            verticalAlign: function() {
                let top = '0%';
                let left = '0%';

                if(this.data.text_valign === 'middle') {
                    top = '50%';
                } else if(this.data.text_valign === 'bottom') {
                    top = '100%';
                }

                if(this.data.text_align === 'center') {
                    left = '50%';
                } else if(this.data.text_align === 'right') {
                    left = '100%';
                }

                return {
                    position: 'relative',
                    top: top,
                    left: left,
                    transform: 'translate(-' + left + ',-' + top + ')',
                }
            },
            textDecoration: function () {
                if (this.data.text_decoration === 'underline') {
                    return 'underline';
                }

                return 'none';
            },
            fontStyle: function () {
                if (this.data.text_style === 'italic') {
                    return 'italic';
                }

                return 'normal';
            },
            fontWeight: function () {
                if (this.data.text_weight === 'bold') {
                    return 'bold';
                }

                return 'normal';
            },
            currentTime: function () {
                return this.hours + ':' + this.minutes;
            }
        },
        methods: {
            updateTime: function () {
                let now = new Date();
                this.hours = ('0' + now.getHours()).slice(-2);
                this.minutes = ('0' + now.getMinutes()).slice(-2);
            }
        },
        mounted() {
            this.updateTime();
            const millisUntilNextFullSecond = 1000 - (new Date()).getMilliseconds()
            this.timeoutHandle = setTimeout(() => {
                this.intervalHandle = setInterval(this.updateTime, 1000);
            }, millisUntilNextFullSecond + 16)
        },
        beforeDestroy() {
            clearTimeout(this.timeoutHandle)
            clearInterval(this.intervalHandle)
        }
    }
</script>
